import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import SideMenu from './common/SideMenu';
import ApplicationList from './Application/ApplicationList';
import BeneficiaryList from './Beneficiary/BeneficiaryList';
import BeneficiaryDetail from './Beneficiary/BeneficiaryDetail';
import FundRequestList from './FundRequest/FundRequestList';
import ApplicationDetail2 from './Application/ApplicationDetail2';
import TerminationList from './Termination';
import Dashboard from './Dashboard';
import Receipt from './Receipt';
import TopMenu from './common/TopMenu';
import Transfer from './Transfer';
import FundRequestView from './FundRequest/FundRequestView';
import Search from './Search';
import YourProfile from './UserManagement/YourProfile';
import PartnerList from './UserManagement/PartnerList';
import BeneUpload from '../BeneUpload/BeneUpload';
import RegistrastionV2 from './Registration';
import '../../assets/css/themify-icons.css';
import '../../assets/css/animate.min.css';
import '../../assets/css/paper-dashboard.css';
import Login from '../Login';
import Registration from '../Registration';
import DownloadPDF from '../Registration/DownloadPDF';
// import { getSalesforceToken } from '../../actions/salesforces';

class ParentLayout extends React.Component {
    constructor(props) {
        super(props);
        this.openFunction = this.openFunction.bind(this);
        this.state = {
            sideMenuClass: 'sidebar',
            isToggled: false,
        };
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location) => {
            const { loggedInUser } = JSON.parse(localStorage.getItem('reduxPersist:user'));
            if (loggedInUser === null) window.location.reload();
        });
    }

    async componentDidMount() {
        // Disabled not secure method
        // await this.props.getSalesforceToken();
    }

    componentWillReceiveProps() {
        this.openFunction();
    }

    componentWillUnmount() {
        this.unlisten();
    }

    // made function to open sidemenu in small browser screen
    openFunction() {
        this.setState({
            isToggled: !this.state.isToggled,
        }, () => {
            if (this.state.isToggled) {
                this.setState({
                    sideMenuClass: 'sideMenuSmallScreen sidebar',
                });
            } else {
                this.setState({
                    sideMenuClass: 'sidebar',
                });
            }
        });
    }

    render() {
        const { props } = this;
        if (props.currentUser.loggedInUser === null) {
            return (
                <Redirect
                    to={{
                        pathname: '/',
                        state: { from: props.location },
                    }}
                />
            );
        }
        const title = props.currentUser.loggedInUser.Partner_Authority__c !== null ? 'STSPMF Partner Portal' : 'STSPMF Beneficiary Portal';
        return (
            <div className="wrapper">
                <div className={this.state.sideMenuClass} data-background-color="white" data-active-color="danger">
                    <SideMenu location={props.location} {...props} />
                </div>
                <div className="main-panel">
                    <TopMenu title={title} user={props.currentUser} openFunction={this.openFunction} location={props.location} />
                    <div className="content">
                        <div className="container-fluid">
                            <TransitionGroup>
                                <CSSTransition key={props.location.key} classNames="fade" timeout={300}>
                                    <Switch location={props.location}>
                                        <Route exact path="/portal/" component={Dashboard} />
                                        <Route path="/portal/applications" component={ApplicationList} />
                                        <Route path="/portal/application/:applicantionId" component={ApplicationDetail2} />
                                        <Route path="/portal/beneficiary/:id" component={BeneficiaryDetail} />
                                        <Route path="/portal/beneficiaries" component={BeneficiaryList} />
                                        <Route exact path="/portal/fund-request" component={FundRequestList} />
                                        <Route exact path="/portal/fund-request/:id" component={FundRequestView} />
                                        <Route path="/portal/termination" component={TerminationList} />
                                        <Route path="/portal/transfer" component={Transfer} />
                                        <Route path="/portal/receipt" component={Receipt} />
                                        <Route path="/portal/search/:query" component={Search} />
                                        <Route path="/portal/profile" component={YourProfile} />
                                        <Route path="/portal/user-management" component={PartnerList} />
                                        <Route path="/portal/registration/draft/:registrationId" component={Registration} />
                                        <Route path="/portal/registration" component={Registration} />
                                        <Route path="/portal/registration/download/:id" component={DownloadPDF} />
                                        <Route path="/portal/registration-v2" component={RegistrastionV2} />
                                        <Route path="/portal/bene-upload" component={BeneUpload} />
                                        <Route exact path="/" component={Login} />
                                        <Route
                                            render={(props2) => {
                                                window.location = `/404.html?from=${props2.location.pathname}`;
                                            }}
                                        />
                                    </Switch>
                                </CSSTransition>
                            </TransitionGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ParentLayout.propTypes = {
    location: PropTypes.object,
    currentUser: PropTypes.object,
    history: PropTypes.object.isRequired,
};
ParentLayout.defaultProps = {
    location: {},
    currentUser: null,
};
const mapDispatchToProps = dispatch => (
    bindActionCreators({
        // getSalesforceToken,
    }, dispatch)
);
const mapStateToProps = state => ({
    currentUser: state.user,
    salesforce: state.salesforce,
});
export default connect(mapStateToProps, mapDispatchToProps)(ParentLayout);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/index.js
// module id = 784
// module chunks = 0